import { ReactNode, useState } from 'react'
import { Helmet } from 'react-helmet'
import { Trans } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import SideMenu from '../SideMenu'
import { useTranslation } from '../../hooks'
import { login } from '../../lib/icp'
import pages from '../../pages'
import { Button } from '../../components'

import Header from '../Header'
import { changeLanguage, languages } from '../../translations/i18n'
import pkg from '../../../package.json'

import styles from './Page.module.scss'

const year = new Date().getFullYear()

// type MaybeUser = User | null | undefined
interface MenuItem {
  icon: string
  url?: string
  name: string
  id: string | number
  // shouldShow?: (
  //   userData?: MaybeUser,
  //   userPermissions?: UserPermission[],
  // ) => boolean | undefined
}

const MENU_ITEMS: MenuItem[] = [
  {
    icon: 'https://yumi-frontend-assets.s3.ap-east-1.amazonaws.com/yumi/unity/1687162925672_Home.svg',
    url: '/',
    name: 'Home',
    id: 1,
  },
  {
    icon: 'https://yumi-frontend-assets.s3.ap-east-1.amazonaws.com/yumi/unity/1687162925674_Shorts.svg',
    url: '',
    name: 'Shorts',
    id: 2,
  },
  {
    icon: 'https://yumi-frontend-assets.s3.ap-east-1.amazonaws.com/yumi/unity/1687162925663_Subscriptions.svg',
    url: '/?s=recommended&t=weekly',
    name: 'subscriptions',
    id: 3,
  },
  {
    icon: 'https://yumi-frontend-assets.s3.ap-east-1.amazonaws.com/yumi/unity/1687162925673_Messages.svg',
    url: '',
    name: 'messages',
    id: 4,
  },
]

// const history = useHistory()
// const [current]

const Page = ({
  title,
  children,
  disableFooter,
  center,
  className,
}: PageProps) => {
  const [showModal, setShowModal] = useState<boolean>(false)

  const [loginModal, setLoginModal] = useState<boolean>(false)

  const { t } = useTranslation()
  const closeModal = () => {
    setShowModal(false)
    document.body.style.removeProperty('overflow')
  }
  const showTips = () => {
    setShowModal(true)
    document.body.style.setProperty('overflow', 'hidden')
  }
  // 登录
  const click_login = () => {
    setLoginModal(true)
  }

  const closeLoginModal = () => {
    setLoginModal(false)
  }

  const history = useHistory()

  const signUp = () => {
    login(() => {
      history.push(pages.account.path)
    })
  }
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <script
          async
          defer
          src="https://scripts.simpleanalyticscdn.com/latest.js"
        />
        <meta name="package-version" content={pkg.version} />
        <link
          rel="canonical"
          href={`https://dsocial.app/${window.location.pathname}`}
        />
      </Helmet>
      <div className={`${styles.container} ${center ? styles.center : ''}`}>
        <Header toLogin={click_login} showTips={showTips} />
        <div className={styles.content_wrap}>
          <div className={styles.content_wrap_sidebar}>
            <SideMenu showTips={showTips} />
          </div>
          <div className={`${styles.content} ${className}`}>{children}</div>
        </div>
        {/* {!disableFooter && (
        <div className={styles.footer}>
          <p>
            &copy; {year} DSocial (v{pkg.version}) |{' '}
            <Trans i18nKey="footer">
              Built by
              <a
                href="https://twitter.com/ashappdev"
                target="_blank"
                rel="noreferrer"
              >
                @ashappdev
              </a>
              .
            </Trans>
          </p>

          <div className={styles.languages}>
            {languages.map(([code, emoji, desc]) => (
              <a
                title={desc}
                className={styles.lang}
                key={code}
                onClick={() => changeLanguage(code)}
              >
                {emoji}
              </a>
            ))}
          </div>
        </div>
      )} */}
      </div>
      {/* tips */}
      {showModal && (
        <div className={styles.tips_wrap}>
          <ul className={styles.tips_box}>
            <li className={styles.tips_box_head}>
              <div className={styles.tips_box_head_name}>{t('tipsLng')}</div>
              <img
                onClick={() => closeModal()}
                className={styles.tips_box_head_img}
                src="https://yumi-frontend-assets.s3.ap-east-1.amazonaws.com/yumi/unity/1687661633061_Vector.svg"
                alt=""
              />
            </li>
            <li className={styles.tips_box_middle}>
              <img
                src="https://yumi-frontend-assets.s3.ap-east-1.amazonaws.com/yumi/unity/1687661675773_Frame.png"
                alt=""
              />
            </li>
            <li className={styles.tips_box_bottom}>{t('tipsContentLng')}</li>
          </ul>
        </div>
      )}
      {/* login */}
      {loginModal && (
        <div className={styles.login_wrap}>
          <div className={styles.login_box}>
            <div className={styles.login_box_head}>
              <img
                className={styles.login_box_head_left}
                src="https://yumi-frontend-assets.s3.ap-east-1.amazonaws.com/yumi/unity/1687679479995_LOGODSOCIAL 1.png"
                alt=""
              />
              <img
                onClick={() => closeLoginModal()}
                className={styles.login_box_head_right}
                src="https://yumi-frontend-assets.s3.ap-east-1.amazonaws.com/yumi/unity/1687661633061_Vector.svg"
                alt=""
              />
            </div>
            <h1 className={styles.login_box_title}>{t('loginPageTitle')}</h1>
            <ul className={styles.login_box_ul}>
              <li className={styles.login_box_ul_one}>
                {t('loginIfNotRegistered')}
              </li>
              <li
                className={`${styles.login_box_ul_two} ${styles.mgb_30}`}
                onClick={signUp}
              >
                <button>{t('loginSignUpButton')}</button>
                {/* {t('loginSignUpButton')} */}
              </li>
              <li className={styles.login_box_ul_one}>
                {t('loginIfRegistered')}
              </li>
              <li className={styles.login_box_ul_two} onClick={signUp}>
                {/* {t('loginButton')} */}
                <button>{t('loginButton')}</button>
              </li>
            </ul>
            <div className={styles.login_box_bottom}>
              &copy; {year} DSocial (v{pkg.version}) |{' '}
              <Trans i18nKey="footer">
                Built by
                <a
                  href="https://twitter.com/ashappdev"
                  target="_blank"
                  rel="noreferrer"
                >
                  @ashappdev
                </a>
                .
              </Trans>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

interface PageProps {
  title?: string
  children: ReactNode
  disableFooter?: boolean
  center?: boolean
  className?: string
}

export default Page
